import { IonButton } from "@ionic/react";
import { useState } from "react";
import { ActionType } from "../../models/Enums";
import { SaveEducationProvided } from "../../services/AuthServices";
import { localDateTime } from "../../utils/sharedFunction";
import { useRecoilState } from "recoil";
import { networkConnectionStatus } from "../../data/atoms";
import { useHistory } from "react-router";

interface Props {
  setCompletedEducation: Function;
  patientName: string;
  onClose?: (isEducationProvided?: boolean) => void;
}

const CompletedEducationModal: React.FC<Props> = ({
  setCompletedEducation,
  patientName,
  onClose,
}) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus
  );
  const history = useHistory();

  const handleSubmit = async (option: string) => {
    if (!isButtonDisabled) {
      setIsButtonDisabled(true);
      if (!navigator.onLine) {
        setShowNetWorkRecoil({ isShown: true });
        return;
      }
      try {
        let isEducationProvided = false;
        if (option === "Yes") {
          isEducationProvided = true;
        }
        await SaveEducationProvided({
          PatientId: localStorage.getItem("patientServerID"),
          EncryptedServerId: localStorage.getItem("EncryptedServerId"),
          IsEducationProvided: isEducationProvided,
          localDateTime: localDateTime(),
        }).then(async function (response: any) {
          setIsButtonDisabled(false);
          console.log("Response: ", response);
          if (response.data.id > 0 && onClose) {
            onClose(isEducationProvided);
          }
        });
      } catch (error) {
        history.push("/confirmation", {
          actionType: ActionType.FailureAPIResponse,
        });
        console.error(error);
      }
    }
  };

  return (
    <>
      <div className="py-32 ph-42 text-center flex-column">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="191"
          height="150"
          viewBox="0 0 191 150"
          fill="none"
          className="mb-24 "
        >
          <path
            d="M40.5 20C40.5 8.96875 49.4688 0 60.5 0H170.5C181.531 0 190.5 8.96875 190.5 20V95H160.5V90C160.5 84.4688 156.031 80 150.5 80H130.5C124.969 80 120.5 84.4688 120.5 90V95H80.1562C83.5625 89.125 85.5 82.2812 85.5 75C85.5 52.9062 67.5938 35 45.5 35C43.8125 35 42.125 35.0938 40.5 35.3125V20ZM104.562 130C102.969 122.438 99.4688 115.594 94.5312 110H190.5C190.5 121.031 181.531 130 170.5 130H104.562ZM20.5 75C20.5 68.3696 23.1339 62.0107 27.8223 57.3223C32.5107 52.6339 38.8696 50 45.5 50C52.1304 50 58.4893 52.6339 63.1777 57.3223C67.8661 62.0107 70.5 68.3696 70.5 75C70.5 81.6304 67.8661 87.9893 63.1777 92.6777C58.4893 97.3661 52.1304 100 45.5 100C38.8696 100 32.5107 97.3661 27.8223 92.6777C23.1339 87.9893 20.5 81.6304 20.5 75ZM0.5 140C0.5 123.438 13.9375 110 30.5 110H60.5C77.0625 110 90.5 123.438 90.5 140C90.5 145.531 86.0312 150 80.5 150H10.5C4.96875 150 0.5 145.531 0.5 140Z"
            fill="#802392"
          />
        </svg>
        <p className="generic-heading-32 fw-700 mb-24">
          Were you able to provide education to <br /> {patientName}?
        </p>
        <div className="d-flex justify-content-center w-100 gap-24">
          <IonButton
            placeholder={undefined}
            className="generic-btn-outline mb-0 h-64 fz-26"
            onClick={() => handleSubmit("No")}
            disabled={isButtonDisabled}
          >
            {" "}
            No
          </IonButton>
          <IonButton
            placeholder={undefined}
            className="generic-btn mb-0 h-64 fz-26"
            onClick={() => handleSubmit("Yes")}
            disabled={isButtonDisabled}
          >
            {" "}
            Yes
          </IonButton>
        </div>
      </div>
    </>
  );
};
export default CompletedEducationModal;
